import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import { formatSalesValue } from './../../utils/formatUtils';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);

const BAR_COLORS = [
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
    "#8AC249",
    "#EA5545",
    "#F46A9B",
    "#EF9B20",
    "#EDBF33",
    "#87BC45",
    "#27AEEF",
    "#B33DC6",
];

const EmployeeSalesBarChart = ({ employeeData }) => {
    if (!employeeData || employeeData.length === 0) {
        return <div className="text-center py-4 text-gray-500">No data available for chart</div>;
    }

    const chartData = {
        labels: employeeData.map(emp => emp.Employee),
        datasets: [
            {
                label: "Total Sales",
                data: employeeData.map(emp => emp.Total_Sales),
                backgroundColor: employeeData.map((_, index) =>
                    BAR_COLORS[index % BAR_COLORS.length]
                ),
                borderColor: employeeData.map((_, index) =>
                    BAR_COLORS[index % BAR_COLORS.length]
                ),
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: "Employee Sales Performance",
                font: {
                    size: 16
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return formatSalesValue(context.raw);
                    }
                }
            },
            datalabels: {
                display: false
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        return formatSalesValue(value);
                    }
                },
                title: {
                    display: true,
                    text: 'Total Sales',
                    font: {
                        size: 13
                    }
                }
            },
            x: {
                ticks: {
                    display: true,
                    color: '#4F5255',
                    font: {
                        weight: 'bold'
                    }
                },
                title: {
                    display: true,
                    text: 'Employees',
                    font: {
                        size: 13
                    }
                },
                grid: {
                    display: false
                }
            }
        }
    };

    return (
        <div className="bg-white p-4 rounded-md shadow-md my-20">
            <Bar
                data={chartData}
                options={options}
            />
        </div>
    );
};

export default EmployeeSalesBarChart;